import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M1.2 8.999c0-3.968 2.981-7.247 6.819-7.731L9.151 2.4 7.948 3.603a5.497 5.497 0 1 0-.984 10.503l.959-.959C6.075 12.665 4.7 10.997 4.7 9c0-2.193 1.656-3.987 3.78-4.247L10.849 2.4 8.413.029C3.717.333 0 4.227 0 8.999c0 4.575 3.417 8.345 7.837 8.916l-1.65-1.65C3.274 15.134 1.2 12.307 1.2 8.999zM10.164.083l1.65 1.65C14.726 2.865 16.8 5.691 16.8 8.999c0 3.968-2.98 7.246-6.819 7.731l-1.133-1.132 1.201-1.202a5.497 5.497 0 1 0 .986-10.502l-.959.959C11.925 5.334 13.3 7.002 13.3 9c0 2.193-1.657 3.988-3.781 4.247l-2.368 2.352 2.436 2.371C14.283 17.666 18 13.771 18 8.999 18 4.424 14.583.655 10.164.083z" />
  </svg>
);

export default SvgComponent;
